<template>
  <b-modal
    id="modal-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    title="過瀘"
    title-class="font-weight-bolder"
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    centered
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="類別："
              label-for="filter_quotation_type_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_quotation_type_id"
                v-model="update.filter_quotation_type_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="quotationTypeOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇類別"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="user_type_id !=2">
            <b-form-group
              label="客戶："
              label-for="filter_customer_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_customer_id"
                v-model="update.filter_customer_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customerOptions"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇客戶"
                :filter="customerSearch"
              >
                <template #option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
                <template #selected-option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12">
            <b-form-group
              label="項目："
              label-for="filter_project_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_project_id"
                v-model="update.filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectOptions"
                label="項目"
                :reduce="(option) => option.id"
                placeholder="選擇項目"
                :filter="projectSearch"
              >
                <template #option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
                <template #selected-option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col> -->
          <!-- <b-col cols="12">
            <b-form-group
              label="報價中"
              label-for="filter_stamp_id"
              label-cols-md="3"
            >
              <b-form-checkbox
                :checked="update.filter_quotating"
                name="quotating"
                switch
                inline
                v-model="update.filter_quotating"
                value="1"
                unchecked-value="0"
                style="margin-top: 5px"
              >
                {{ update.filter_quotating ? "是" : "否" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col> -->

          <!-- <b-col cols="12">
            <b-form-group
              label="商品："
              label-for="filter_product_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_product_id"
                v-model="update.filter_product_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="productOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇商品"
              >
              <template #option="{product_name, product_number}">
                [{{ product_number }}] {{ product_name }}
            </template>
            <template #selected-option="{product_name, product_number}">
                [{{ product_number }}] {{ product_name }}
            </template>
              </v-select>
            </b-form-group>
          </b-col> -->
          <!-- <b-col cols="12" v-if="false">
            <b-form-group
              label="公司印章："
              label-for="filter_stamp_id"
              label-cols-md="3"
            >
              <b-form-checkbox
                :checked="update.filter_stamp_id"
                name="stamp"
                switch
                inline
                v-model="update.filter_stamp_id"
                value="1"
                style="margin-top: 5px"
              >
                {{ update.filter_stamp_id ? "有" : "無" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col> -->
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import ability from "@/libs/acl/ability";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter");
    },
    onSubmit() {
      this.$emit(
        "update:filter_quotation_type_id",
        this.update.filter_quotation_type_id
      );
      this.$emit("update:filter_customer_id", this.update.filter_customer_id);
      //this.$emit("update:filter_stamp_id", this.update.filter_stamp_id);
      // this.$emit("update:filter_product_id",this.update.filter_product_id);
      this.$emit("update:filter_project_id", this.update.filter_project_id);
      this.$emit("update:filter_quotating", this.update.filter_quotating);
      this.hide();
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.user_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    // productSearch(options, search){
    //   var returnOptions = options.filter(item => {
    //     return item.product_name.toLowerCase().includes(search.toLowerCase()) || item.product_number.toLowerCase().includes(search.toLowerCase())
    //   })
    //     return returnOptions
    // },
    projectSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.project_name.toLowerCase().includes(search.toLowerCase()) ||
          item.project_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
  },
  watch: {
    filter_quotating(newVal) {
      this.update.filter_quotating = newVal
    }
  },
  props: {
    quotationTypeOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    // productOptions: {
    //   type: Array,
    //   required: true,
    // },
    projectOptions: {
      type: Array,
      required: true,
    },
    filter_quotation_type_id: {},
    filter_customer_id: {},
    // filter_product_id: {},
    filter_project_id: {},
    // filter_stamp_id: {},
    filter_quotating: {},
  },
  data() {
    return {
      loading: false,
      ability,
      user_type_id: JSON.parse(localStorage.getItem("userData")).user_type_id,
      update: {
        filter_quotation_type_id: null,
        filter_customer_id: null,
        filter_quotating: null,
        // filter_product_id:null,
        filter_project_id: null,
        // filter_stamp_id:null
      },
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
